import { AutenticacionService } from './../autenticacion.service';
import { PlazosService } from "../../services/plazos.service";
import { Injectable } from '@angular/core';
declare var $;

/**
* Tipos de créditos
*/
export enum TiposCreditos {
  Hipotecario = 1,
  Automotriz = 2,
  Prendario = 3,
  Verde = 4,
  Personal = 5,
  Nomina = 6,
  Carburacion = 7,
  Estacionario = 8,
  MesesSinIntereses = 9,
  PlusPension = 10
}

//Este enumeration se utiliza en los reportes
export enum CreditosKeys {
  Hipotecario = 'hipotecario',
  Automotriz = 'automotriz',
  Prendario = 'prendario',
  Verde = 'verde',
  Personal = 'personal',
  Nomina = 'nomina',
  Carburacion = 'carburacion',
  Estacionario = 'estacionario'
}

/**
* Estatus de créditos
*/
export enum EstatusCreditos {
  Borrador = 0,
  Pendiente = 1,
  Vigente = 2,
  Finalizado = 3
}

/**
* Archivos de los convenios
*/
export enum ArchivosConvenios {
  ConstanciaLegal = 1,
  ActaConstitutiva = 2,
  ComprobanteDomicilio = 3,
  INE = 4
}

/**
* Tipos de cálculos
*/
export enum TiposCalculos {
  Insoluto = 1,
  Simple = 2,
  Soluto = 3,
  DistribucionCarburacion = 4,
  DistribucionEstacionario = 5,
  MesesSinIntereses = 6
}

export enum OpcionesPago {
  Periodo = 1,
  Minimo = 2,
  Liquidacion = 3,
  CapitalPendiente = 4
}

@Injectable()
export class HelpersService {

  constructor(
    private authService: AutenticacionService,
    private plazosService: PlazosService,
  ) { }

  

  /**
   * Estatus
   */
  public static readonly ESTATUS_BORRADOR : number = 0;
  public static readonly ESTATUS_PENDIENTE : number = 1;
  public static readonly ESTATUS_ENCURSO : number = 2;
  public static readonly ESTATUS_FINALIZADO : number = 2;

  /**
   * Tipos de cálculos
   */
  public static readonly CALCULO_INSOLUTO : number = 1;
  public static readonly CALCULO_SIMPLE : number = 2;
  public static readonly CALCULO_SOLUTO : number = 3;
  public static readonly CALCULO_DIS_CARBURACION : number = 4;
  public static readonly CALCULO_DIS_ESTACIONARIO : number = 5;

  /**
   * Notifications
   */

  public notification(title, description, type) {
    $.NotificationApp.send(title, description, 'bottom-right', 'rgba(0,0,0,0.2)', type);
  }

  public httpGlobalError(error, notification = true) {
    if (error.status == 403) {
      // usuario sin sessión activa
      this.authService.killUser();
    } else if (error.status == 500 && notification) {
      // error en el backend
      this.notificationErrorDefault();
    } else if (error.status == 0) {
      this.notificationErrorDefault();
    }
  }

  public notificationErrorDefault() {
    this.notification('ERROR', 'No se completó la acción. Por favor, inténtelo más tarde', 'error');
  }

  /**
   * Error handlers
   */

  public clearErrorObject(uiErrorObj : any){
    if(!uiErrorObj){
      console.error('El objeto error debe estar inicializado, para poder pasar "por referencia" el valor')
      return;
    }

    Object.keys(uiErrorObj).forEach((key) => {
      delete uiErrorObj[key];
    });
    return uiErrorObj;
  }

   /**
    * 
    * @param errors : Lista de errores que retornan los servicios de Save (Hay errores custom que tienen llaves que necesitan ser parseadas)
    * @param uiErrorObj : Objeto del componente que se utiliza para desplegar los errores en el front
    */
  public showSaveCreditErrors(errors : any, uiErrorObj : any){
    
    if(!uiErrorObj){
      console.error('El objeto error debe estar inicializado, para poder pasar "por referencia" el valor')
      return;
    }

    uiErrorObj = this.clearErrorObject(uiErrorObj);
    Object.keys(errors).forEach(function(key){
        //TODO: Agregar el mapeo de todos los posibles errores en el backend
        switch(key){
        case 'cliente.email':
          uiErrorObj['email'] = errors[key][0];
          break;
        case 'prestamo.monto_prestamo':
            uiErrorObj['monto_prestamo'] = errors[key][0];
            break;
          
        }
    });
  }

  /**
    * 
    * @param errors : Lista de errores que retornan los servicios de Save (Hay errores custom que tienen llaves que necesitan ser parseadas)
    * @param uiErrorObj : Objeto del componente que se utiliza para desplegar los errores en el front
    */
  public setBackendErrors(errors:any, uiErrorObj : any){

    if(!uiErrorObj){
      console.error('El objeto error debe estar inicializado, para poder pasar "por referencia" el valor')
      return;
    }

    uiErrorObj = this.clearErrorObject(uiErrorObj);
        
    Object.keys(errors).forEach(function(key){
      uiErrorObj[key] = errors[key][0];
    });
  }

  /**
   * Cargar catalogo de plazos en el simulador
   */

  public getPlazos(tipoCredito : number, callback : any ){
    this.plazosService.getAll(tipoCredito).subscribe(
        callback, error =>
        {  
          // se resuelve error 403 y 500
          this.httpGlobalError(error);

          if(error.status == 400) {
              this.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
    );
  }

  public getSelectedPlazo(prestamo : any, plazos : any []){
    let selectedPlazo = null;
    plazos.forEach(function(element) {
      
      if(prestamo.plazo_periodo === element.periodo && prestamo.plazo_medida === element.medida){
        selectedPlazo = element;
      }
    });

    return selectedPlazo;
  }

  /**
   * Date helpers
   */

  public laravelDateToString(laravelDate: string) : string{
    function pad(s) { return (s < 10) ? '0' + s : s; }
    let fecha = new Date(laravelDate); 
    return [pad(fecha.getDate()), pad(fecha.getMonth()+1), fecha.getFullYear()].join('-');
  }

  public laravelDateToObj(laravelDate: any){
    var fecha = new Date(laravelDate); 
    return { year: fecha.getFullYear(), month: (fecha.getMonth()+1), day: fecha.getDate()};
  }

  public dateToObj(fecha: Date){
    return { year: fecha.getFullYear(), month: (fecha.getMonth()+1), day: fecha.getDate()};
  }

  public dateToString(jsonDate: any){
    let month = (('0' + jsonDate.month).slice(-2));
    let day = (('0' + jsonDate.day).slice(-2));
    return `${jsonDate.year}-${month}-${day} 00:00:00`;
  }
}


// WEBPACK FOOTER //
// ./src/app/services/tools/helpers.service.ts